import { useStaticQuery, Link, graphql } from "gatsby"
import React, { useState } from "react"
import AnimateHeight from "react-animate-height"
import { IoIosArrowDown } from "react-icons/io"

import { submenuLink } from "./account.module.css"
const Menu = ({ openTab }) => {
  const { category, subcategory } = useStaticQuery(
    graphql`
      {
        category: allSanityCategory {
          nodes {
            title
            _id
            slug {
              current
            }
          }
        }
        subcategory: allSanitySubcategory {
          nodes {
            id
            category {
              _id
              slug {
                current
              }
            }
            slug {
              current
            }
            title
          }
        }
      }
    `
  )
  const categories = category.nodes
  const subcategories = subcategory.nodes
  const [index, setIndex] = useState(null)
  const [height, setHeight] = useState(0)

  const toggle = i => {
    setIndex(i)
    setHeight("auto")
  }
  return (
    <div className={openTab === 1 ? "block" : "hidden"} id="link2">
      {categories.map((category, i) => {
        const subCate = subcategories.filter(
          sub => sub.category._id === category._id
        )
        const active = index === i
        return (
          <div key={category._id} className="mb-3 border shadow-lg  capitalize">
            <button
              aria-controls={`panel-${i}`}
              aria-expanded={height !== 0}
              onClick={() => toggle(i)}
              className={`flex justify-between align-middle items-center w-full border-bhover:bg-black hover:text-white ${
                active ? "bg-black text-white" : ""
              }`}
            >
              <h2 className="p-2 border-r w-5/6">{category.title}</h2>
              <Link to={`/${category.slug.current}`} className="w-1/6 ">
                <IoIosArrowDown
                  className={`inline-block transition-transform duration-200 ${
                    active ? "rotate-180" : "rotate-0"
                  }`}
                />
              </Link>
            </button>
            <AnimateHeight
              id={`panel-${i}`}
              height={active ? height : 0}
              className="AnimateHeight"
            >
              <ul className={submenuLink}>
                {subCate.map(s => {
                  return (
                    <li key={s.id}>
                      {" "}
                      <Link
                        to={`/${s.category.slug.current}/${s.slug.current}`}
                      >
                        {s.title}
                      </Link>
                    </li>
                  )
                })}
              </ul>
            </AnimateHeight>
          </div>
        )
      })}
    </div>
  )
}

export default Menu
